import React, { useState, useEffect, useRef } from "react";
import Response_Processing from "../../../../src/layout/Others/Response_Processing";
import FormContainer from "../../../components/CommonComponents/FormContainer";
import LeftWrapper from "../../../components/CommonComponents/LeftWrapper";
import RightWrapper from "../../../components/CommonComponents/RightWrapper";
import Wrapper from "../../../components/CommonComponents/Wrapper";
import MessageHeading from "../../../components/CommonComponents/MessageHeading";
import MessageLabel from "../../../components/CommonComponents/MessageLabel";
import AdminDownloadFile from "../../../components/CommonComponents/AdminDownloadFile";
import { BsFiletypeXlsx } from "react-icons/bs";
import { toast } from "react-toastify";
import AdminSaveHeader from "../../../components/CommonComponents/AdminSaveHeader";
import { useMyContext } from "../../../components/Provider/CommonProvider";
import Defaultloadinggif from "../../../layout/Others/Defaultloadinggif";
import AdminImageUploadZone from "../../../components/CommonComponents/AdminImageUploadZone";

function ImportUser() {

  const { fetchRequest } = useMyContext()

  const [showOverlay, setShowOverlay] = useState(false);
  const [labelDisplay, setLabelDisplay] = useState([]);
  const [withOutRefresh, setWithOutRefresh] = useState(false)
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState("");
  const [defaultOption, setDefaultOption] = useState({
    state: "defaultOption",
  })
  const [formDataError, setFormDataError] = useState("")
  const combinedRef = useRef({})

  const baseURL = process.env.REACT_APP_Baseurl
  const storeApi = `${baseURL}/admin/users/bulk-import`
  const createApi = `${baseURL}/admin/users/import-sample-file`
  const labelApi = `${baseURL}/admin/Label-Management/list-source`

  const handleFileChange = async (event) => {
    const { files, name, value, accept } = event.target
    const selectedFile = files[0];
    if (selectedFile) {

      const fileExtension = selectedFile?.name?.split('.').pop().toLowerCase();
      const readFile = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = (error) => reject(error);
          reader.readAsDataURL(file);
        });
      };
      const fileContent = await readFile(selectedFile);

      if (fileExtension !== 'xlsx') {
        setFormDataError('Please upload a valid .xlsx file.');
        setFormData(null);
      } else {
        setFormData(selectedFile);
        setFormDataError('');
      }
    }
  }

  const handleClearSelectFile = (value) => {
    setFormData(null)
  }

  const handleStore = async () => {
    if (formDataError?.length) {
      combinedRef.current['file'].focus()
      return
    }
    if (!formData) {
      combinedRef.current['file'].focus()
      setFormDataError('Please provide xlsx file.');
      return
    }
    const formDataFile = new FormData()
    formDataFile.append("file", formData)
    setShowOverlay(true)
    await await fetchRequest({
      method: 'POST',
      url: `${storeApi}`,
      params: {},
      data: formDataFile
    })
      .then(response => {
        if (response?.status) {
          toast.success(response?.message)
          setWithOutRefresh((prev) => !prev)
          setFormData(null)
        }
      }).catch((error) => {
        toast.error(error?.response?.data?.message)
      }).finally(() => {
        setShowOverlay(false)
      })
  }

  useEffect(async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${createApi}`,
      params: {},
      data: {},
    })
      .then(response => {
        if (response?.status) {
          setDefaultOption((prev) => ({
            ...prev,
            sampleFile: response.Sample_file_path,
          }))
        }
      }).catch((error => {
        toast.error(error?.response?.data?.message || "Something went wrong sample file")
      })).finally(() => {
        setLoading(false)
      })
  }, [withOutRefresh]);

  useEffect(async () => {
    setLoading(true)
    await fetchRequest({
      method: 'GET',
      url: `${labelApi}`,
      params: { source: "add-users" },
      data: {},
    })
      .then((response) => {
        setLabelDisplay(response?.label_management)
      }).catch((error) => {
        toast.error(error?.response?.data?.message || "Something went wrong label api")
      }).finally(() => {
        setLoading(false)
      })
  }, [])

  if (loading) {
    return <Defaultloadinggif className={"heightOnLoader"} />
  }
  return (
    <>
      {showOverlay && (<Response_Processing />)}
      <AdminSaveHeader heading={labelDisplay?.[14]?.title} saveText={labelDisplay?.[19]?.title} saveMethod={handleStore} loading={showOverlay} />
      <FormContainer>
        <LeftWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[15]?.title} />
            <MessageLabel text={labelDisplay?.[16]?.title} className="mandatorySimple" />
            <AdminImageUploadZone
              onChange={handleFileChange}
              selectedFile={formData}
              onDelete={handleClearSelectFile}
              ref={(el) => (combinedRef.current.file = el)}
              name="file"
              error={formDataError}
              accept={".xlsx"}
              icon={<BsFiletypeXlsx />}
            />
          </Wrapper>
        </LeftWrapper>
        <RightWrapper>
          <Wrapper>
            <MessageHeading text={labelDisplay?.[17]?.title} />
            <MessageLabel text={labelDisplay?.[18]?.title} />
            <AdminDownloadFile name="Download" link={defaultOption?.sampleFile} icon={<BsFiletypeXlsx className="dark-green" />} value="yes" />
          </Wrapper>
        </RightWrapper>
      </FormContainer>
    </>
  );
}
export default ImportUser;